module.exports = __webpack_public_path__ + "img/img_3.524d87a7.png";